import { logDevelopmentMessage } from "./logDevelopmentMessage"

function loadScript(src: string) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = src

    script.onload = function (ev) {
      logDevelopmentMessage('[MIAW] Script loaded successfully.')
      resolve(ev)
    }

    script.onerror = function () {
      logDevelopmentMessage(`[MIAW] Failed to load script: ${src}`)
      reject(new Error(`[MIAW] Failed to load script: ${src}`))
    }

    if (!document.querySelector(`script[src="${src}"]`)) {
      document.body.appendChild(script)
    } else {
      logDevelopmentMessage(`[MIAW] Script already loaded: ${src}`)
      resolve({ message: `[MIAW] Script already loaded: ${src}` })
    }
  })
}

export default loadScript;